<div class="filter-dialog">
  <div class="header">
    <h1>ФИЛЬТР</h1>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form class="form" [formGroup]="form">
    <pas-multi-select2 label="Архив"
                       [options]="archiveStatuses"
                       [formControlName]="'archive'">
      <ng-template #optionTemplate let-option>
        {{ option.name }}
      </ng-template>
      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <pas-multi-select2 label="Индекс"
                       [options]="indexes"
                       [formControlName]="'index'"
                       (input)="dataIndex.set($event)"
    >
      <ng-template #optionTemplate let-option>
        {{ option.name }} ({{option.shortName}})
      </ng-template>
      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <pas-multi-select2 label="Учреждение"
                       [options]="organizations"
                       [formControlName]="'organization'"
                       (input)="dataOrganization.set($event)"
    >
      <ng-template #optionTemplate let-option>
        {{ option.name }}
      </ng-template>
      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <pas-multi-select2 label="Тип оценки"
                       [options]="periods"
                       [formControlName]="'period'"
    >
      <ng-template #optionTemplate let-option>
        {{ option.name }}
      </ng-template>
      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <pas-multi-select2 label="Год"
                       [options]="years"
                       [formControlName]="'year'"
    >
      <ng-template #optionTemplate let-option>
        {{ option.name }}
      </ng-template>
      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <pas-multi-select2 label="Квартал"
                       [options]="quarters"
                       [formControlName]="'quarter'"
    >
      <ng-template #optionTemplate let-option>
        {{ option.name }}
      </ng-template>
      <ng-template #selectedTemplate let-selected>
        {{ selected.name }}
      </ng-template>
    </pas-multi-select2>

    <br/>

  </form>
  <div mat-dialog-actions>
    <button [ngClass]="['btn', form.status==='VALID' ? 'btn-blue': 'btn-gray']"
            [ngStyle]="{color:form.status==='VALID' ? '#fff' : '#777'}"
            mat-button cdkFocusInitial [disabled]="form.status!=='VALID'" (click)="onApply()">Применить
    </button>
    <button class="btn btn-secondary" mat-button (click)="onReset()">Сбросить</button>
  </div>
</div>
